import { useSearchParams } from "react-router-dom";
import BOMStepHeader from "../BomStepHeader";
import BomGeneralDetails from "../BomGeneralDetails";
import BomClinicPricingMapping from "../BomClinicPricingMapping";

const BOMSetupOnboard = () => {
  const [params] = useSearchParams();
  const pageStep = params.get("page_step");
  let step = 2;
  if (pageStep === "general" || pageStep === "general_details") step = 2;
  if (pageStep === "clinic_price") step = 3;

  return (
    <div className="relative mt-6 px-4 sm:px-6">
      <BOMStepHeader step={step} />
      {step === 2 && <BomGeneralDetails />}
      {step === 3 && <BomClinicPricingMapping />}
    </div>
  );
};

export default BOMSetupOnboard;
